import React from 'react';
import styles from '../styles/interactive-docs.module.css';
import { SearchIcon, MenuIcon, CloseIcon } from '../../../components/Icon';

const DocsHeader = ({
    projectName = 'IChis SPD',
    onOpenSearch,
    onBackToApp,
    isMobileMenuOpen,
    onToggleMobileMenu
}) => {
    return (
        <header className={styles.docsHeader}>
            <div className={styles.brandGroup}>
                {/* Кнопка меню для мобильных устройств */}
                <button
                    className={styles.mobileMenuToggle}
                    onClick={onToggleMobileMenu}
                    aria-label="Меню навигации"
                >
                    {isMobileMenuOpen ? <CloseIcon size={18} /> : <MenuIcon size={18} />}
                </button>

                <div className={styles.brandTitleCombined}>
                    <span className={styles.brandLogoPill}>ICHIS</span>
                    <span className={styles.brandDocsWord}>Документация</span>
                </div>
                <span className={styles.brandDivider}>/</span>
                <span className={styles.projectBadgeHighlight}>{projectName}</span>
            </div>

            <div className={styles.headerActions}>
                <button
                    className={styles.searchTrigger}
                    onClick={onOpenSearch}
                    title="Поиск по документации (Ctrl + K или /)"
                >
                    <SearchIcon size={14} />
                    <span className={styles.searchTriggerText}>Поиск...</span>
                    <span className={styles.searchKbd}>/</span>
                </button>

                {onBackToApp && (
                    <button
                        className={styles.headerBtn}
                        onClick={onBackToApp}
                        title="Вернуться в рабочее пространство"
                    >
                        <span>В систему</span>
                    </button>
                )}
            </div>
        </header>
    );
};

export default DocsHeader;
